module.exports = __webpack_public_path__ + "static/img/consumermain.90d76ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/consumermain.png
// module id = U+1m
// module chunks = 0